import React from 'react';
import { Container, Typography, Box } from '@mui/material';
localStorage.removeItem("cart");
const OrderConfirmation = () => {
  return (
    
    <Container maxWidth="sm" sx={{ textAlign: 'center', mt: 5 }}>
      <Typography variant="h4" gutterBottom>
        ¡Gracias por tu compra!
      </Typography>
      <Typography variant="body1" gutterBottom>
        Tu pedido ha sido confirmado. A continuación, encontrarás los detalles de tu compra:
      </Typography>
      {/* Aquí se mostrarán los detalles del pedido */}
      <Box sx={{ mt: 3, mb: 5 }}>
        {/* Reemplaza esto con la lógica para mostrar los productos comprados */}
        <Typography variant="h6">Resumen del Pedido:</Typography>
        <Typography>Producto 1 - Cantidad: 2 - Precio: $1000</Typography>
        <Typography>Producto 2 - Cantidad: 1 - Precio: $500</Typography>
        <Typography variant="h6" sx={{ mt: 2 }}>Total: $1500</Typography>
      </Box>
      <Typography variant="body2" color="textSecondary">
        Si tienes alguna duda sobre tu pedido, contáctanos a través de nuestro formulario de soporte.
      </Typography>
    </Container>
  );
};

export default OrderConfirmation;
